import * as Yup from "yup";
import i18next from "../../../i18n";

/**
 * Values `RoleForm` runs through React Hook Form + Yup. The ability selection is deliberately NOT
 * part of this — it's a plain `Set<string>` state in the form component (same split
 * `UserGroupForm` uses for its member list); a role may legitimately have no abilities.
 */
export type RoleFormValues = {
  name: string;
  description: string;
};

/**
 * Validation for the create/edit role form (`POST` / `PUT /roles`). `.trim()` runs before
 * `.required()`, so a whitespace-only name fails too — same as `userGroupValidationSchema`.
 */
export const roleValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required(i18next.t("roles.nameRequired")),
  description: Yup.string().default(""),
});
